<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <div class="component-header-title">
      <h2>Edit Shareholder Proposal Name</h2>
      @if (proposalNameData?.fullName) {
        <p class="component-header-subtitle">{{ proposalNameData?.fullName }}</p>
      }
      @if (form.get('year')?.value) {
        <p class="component-header-subtitle-secondary">{{ form.get('year')?.value }}</p>
      }
    </div>
  </div>
  <app-company-vote-proposal-name-form
    [form]="form"
    [isEditMode]="true"
    [showYearWarning]="showYearWarning"
    submitButtonText="Update Shareholder Proposal Name"
    (submit)="onSubmit()"
    (cancel)="onCancel()"
    (yearChange)="onYearChange($event)">
  </app-company-vote-proposal-name-form>
</div>
